var map = {
	"./bg-1.jpg": 6628,
	"./bg-10.jpg": 8080,
	"./bg-2.jpg": 240,
	"./bg-3.jpg": 8052,
	"./bg-4.jpg": 912,
	"./bg-5.jpg": 5927,
	"./bg-6.jpg": 884,
	"./bg-7.jpg": 796,
	"./bg-8.jpg": 7096,
	"./bg-9.jpg": 5360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1876;